import { render, staticRenderFns } from "./redemption-drawer.vue?vue&type=template&id=3fda3105&scoped=true&"
import script from "./redemption-drawer.vue?vue&type=script&lang=js&"
export * from "./redemption-drawer.vue?vue&type=script&lang=js&"
import style0 from "./redemption-drawer.vue?vue&type=style&index=0&id=3fda3105&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda3105",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
